export default __webpack_public_path__ + "static/media/Inter-UI-Black.4ea97551.woff";